module.exports = __webpack_public_path__ + "static/media/renta-vitalicia.7a7eaf57.png";